import type { Companion } from "@/game/types";
import { healthLabel } from "@/game/format";
import { Progress } from "@/components/ui/progress";
import { cn } from "@/lib/utils";

export function PartyPanel({ party }: { party: Companion[] }) {
  return (
    <div className="space-y-2">
      <h3 className="font-pixel text-[10px] uppercase tracking-wider text-muted-foreground">
        Your Party
      </h3>
      <div className="grid gap-2 sm:grid-cols-2">
        {party.map((p) => {
          const hl = healthLabel(p.alive ? p.health : 0);
          return (
            <div
              key={p.name}
              className={cn(
                "rounded-md border bg-card px-3 py-2",
                !p.alive && "opacity-60",
              )}
            >
              <div className="flex items-center justify-between">
                <span className="font-terminal text-xl">
                  {p.alive ? "🧑‍🌾" : "🪦"} {p.name}
                </span>
                <span className={cn("font-pixel text-[9px]", hl.className)}>
                  {hl.label}
                </span>
              </div>
              {p.alive && (
                <>
                  <Progress value={p.health} className="mt-2 h-2" />
                  {p.ailment && (
                    <p className="mt-1 font-terminal text-base text-destructive">
                      Suffering from {p.ailment}
                    </p>
                  )}
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
